// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

:host {
  /*font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;*/
  background-color: #ffffff;
  /*padding: 24px;*/
  /*min-height: 100vh;*/
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: stretch;
  padding-top: 24px;
}

.grid-container {
    width: 100%;
    /*max-width: 1200px;*/
    /*margin: 0 auto;*/
}

.tiles-grid {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.tiles-row {
    display: flex;
    gap: 8px;
    width: 100%;
}

.tile-item {
    flex: 1;
    min-width: 0;
    max-width: 33%;
    background-color: #ffffff;
    border: 1px solid #ccdce4;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 8px 8px 16px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    position: relative;
    overflow: hidden;
}

.tile-item:hover {
    /*transform: translateY(-2px);*/
    box-shadow: 0 4px 12px rgba(0, 50, 82, 0.1);
    background: var(--Colors-UI-Primary-Primary-Medium, #E6F2FF);
    border-color: var(--Colors-UI-Primary-Primary-Dark, #0078D4);
}

.tile-item:active {
    /*transform: translateY(0);*/
    box-shadow: 0 2px 6px rgba(0, 50, 82, 0.1);
}

.tile-item.selected {
    background: var(--Colors-UI-Primary-Primary-Medium, #E6F2FF);
    border-color: var(--Colors-UI-Primary-Primary-Dark, #0078D4);
}

.link-icon {
  height: 25px;
}

.tile-name {
    font-weight: 700;
    font-size: 16px;
    color: #113e57;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    user-select: none;
}

.tile-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: none;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease;
    padding: 8px;
}

.tile-button:hover {
    background-color: rgba(78, 117, 142, 0.1);
}

.tile-button svg {
    width: 24px;
    height: 24px;
    fill: #4E758E;
}

/* Responsive design */
@media (max-width: 1024px) {
    .tiles-row {
        flex-wrap: wrap;
    }
    
    .tile-item {
        min-width: calc(50% - 4px);
    }
}

@media (max-width: 768px) {
    body {
        padding: 16px;
    }
    
    .tiles-grid {
        gap: 6px;
    }
    
    .tiles-row {
        gap: 6px;
        flex-direction: column;
    }
    
    .tile-item {
        min-width: 100%;
        padding: 12px 12px 12px 16px;
    }
    
    .tile-name {
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    body {
        padding: 12px;
    }
    
    .tile-item {
        padding: 10px 10px 10px 14px;
    }
    
    .tile-name {
        font-size: 13px;
    }
    
    .tile-button {
        width: 28px;
        height: 28px;
    }
    
    .tile-button svg {
        width: 20px;
        height: 20px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/tiles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;EACE,6FAA6F;EAC7F,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,2CAA2C;IAC3C,4DAA4D;IAC5D,4DAA4D;AAChE;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,4DAA4D;IAC5D,4DAA4D;AAChE;;AAEA;EACE,YAAY;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;QACR,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n:host {\n  /*font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;*/\n  background-color: #ffffff;\n  /*padding: 24px;*/\n  /*min-height: 100vh;*/\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  align-items: stretch;\n  padding-top: 24px;\n}\n\n.grid-container {\n    width: 100%;\n    /*max-width: 1200px;*/\n    /*margin: 0 auto;*/\n}\n\n.tiles-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 100%;\n}\n\n.tiles-row {\n    display: flex;\n    gap: 8px;\n    width: 100%;\n}\n\n.tile-item {\n    flex: 1;\n    min-width: 0;\n    max-width: 33%;\n    background-color: #ffffff;\n    border: 1px solid #ccdce4;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 8px 8px 16px;\n    cursor: pointer;\n    transition: all 0.2s ease-in-out;\n    position: relative;\n    overflow: hidden;\n}\n\n.tile-item:hover {\n    /*transform: translateY(-2px);*/\n    box-shadow: 0 4px 12px rgba(0, 50, 82, 0.1);\n    background: var(--Colors-UI-Primary-Primary-Medium, #E6F2FF);\n    border-color: var(--Colors-UI-Primary-Primary-Dark, #0078D4);\n}\n\n.tile-item:active {\n    /*transform: translateY(0);*/\n    box-shadow: 0 2px 6px rgba(0, 50, 82, 0.1);\n}\n\n.tile-item.selected {\n    background: var(--Colors-UI-Primary-Primary-Medium, #E6F2FF);\n    border-color: var(--Colors-UI-Primary-Primary-Dark, #0078D4);\n}\n\n.link-icon {\n  height: 25px;\n}\n\n.tile-name {\n    font-weight: 700;\n    font-size: 16px;\n    color: #113e57;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 1;\n    user-select: none;\n}\n\n.tile-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: none;\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    padding: 8px;\n}\n\n.tile-button:hover {\n    background-color: rgba(78, 117, 142, 0.1);\n}\n\n.tile-button svg {\n    width: 24px;\n    height: 24px;\n    fill: #4E758E;\n}\n\n/* Responsive design */\n@media (max-width: 1024px) {\n    .tiles-row {\n        flex-wrap: wrap;\n    }\n    \n    .tile-item {\n        min-width: calc(50% - 4px);\n    }\n}\n\n@media (max-width: 768px) {\n    body {\n        padding: 16px;\n    }\n    \n    .tiles-grid {\n        gap: 6px;\n    }\n    \n    .tiles-row {\n        gap: 6px;\n        flex-direction: column;\n    }\n    \n    .tile-item {\n        min-width: 100%;\n        padding: 12px 12px 12px 16px;\n    }\n    \n    .tile-name {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 480px) {\n    body {\n        padding: 12px;\n    }\n    \n    .tile-item {\n        padding: 10px 10px 10px 14px;\n    }\n    \n    .tile-name {\n        font-size: 13px;\n    }\n    \n    .tile-button {\n        width: 28px;\n        height: 28px;\n    }\n    \n    .tile-button svg {\n        width: 20px;\n        height: 20px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
